module.exports = "/dog-racing/img/hr-blue-btn.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/dog-racing/img/hr-blue-btn.png
// module id = 1956
// module chunks = 7